module.exports = __webpack_public_path__ + "static/media/person.e138b85b.png";